export enum StepperState {
  Full = "Full",
  Half = "Half",
  None = "None",
}

/**
 * A component that displays a stepper with a label.
 * @param children The label to display.
 * @param activeState The state of the stepper.
 * @returns A component that displays a stepper with a label.
 */
const Stepper = ({ children, activeState = StepperState.None }: { children: React.ReactNode; activeState: StepperState }) => {
  return (
    <div className="flex flex-col">
      <div className="relative h-3 flex justify-center items-center">
        <hr className={`${activeState !== StepperState.None ? "border-docnote-orange" : "border-docnote-grey-dark"} w-1/2`} />
        <span className={`absolute w-3 h-3 block rounded-full ${activeState !== StepperState.None ? "bg-docnote-orange" : "bg-docnote-grey-dark"}`} />
        <hr className={`${activeState === StepperState.Full ? "border-docnote-orange" : "border-docnote-grey-dark"} w-1/2`} />
      </div>
      <div className={`w-full text-center text-xs ${activeState !== StepperState.None ? "text-docnote-orange" : "text-docnote-grey-dark"}`}>
        {children}
      </div>
    </div>
  );
};

export default Stepper;
